import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";

const AMBIANCE = [
    "https://images.unsplash.com/photo-1716504628084-97224213ca6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxiZWF1dGlmdWwlMjBpbmRpYW4lMjB3b21hbiUyMGhhaXJ8ZW58MHx8fHwxNzg2NzI4NDQ0fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1615292026763-3af006e59a67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxiZWF1dGlmdWwlMjBpbmRpYW4lMjB3b21hbiUyMGhhaXJ8ZW58MHx8fHwxNzg2NzI4NDQ0fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1643168343279-3f93c2e592ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwYmVhdXR5JTIwY29zbWV0aWNzJTIwcHJvZHVjdHMlMjBmbGF0bGF5fGVufDB8fHx8MTc4NjcyODQ0NHww&ixlib=rb-4.1.0&q=85",
];

export default function Categories() {
    const [cats, setCats] = useState([]);
    useEffect(() => { api.get("/categories").then(({ data }) => setCats(data.categories)); }, []);

    return (
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-10 md:py-14">
            <p className="eyebrow mb-3">Browse</p>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-10">Categories</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {cats.map((c, i) => (
                    <Link key={c.id} to={`/shop?category=${encodeURIComponent(c.name)}`} data-testid={`category-${c.slug}`} className="group relative overflow-hidden bg-ink aspect-[16/10] flex items-end p-6">
                        <img src={c.image_url ? mediaUrl(c.image_url) : AMBIANCE[i % AMBIANCE.length]} alt={c.name} className="absolute inset-0 w-full h-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-105" />
                        <div className="relative">
                            <h3 className="text-white font-serif text-2xl">{c.name}</h3>
                            {c.subcategories?.length > 0 && <p className="text-white/70 text-sm mt-1">{c.subcategories.join(" · ")}</p>}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
